exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mb10[data-v-9852ca58] {\n  margin-bottom: 10px;\n}\n.mt10[data-v-9852ca58] {\n  float: right;\n  margin-top: 10px;\n}\n", ""]);

// exports
